<template lang="pug">
.send-message-target-modal
  b-modal(v-model="_show" size="lg" @ok="add" @cancel="cancel")
    template(#modal-header="{ cancel }")
      .send-message-target-modal-header.d-flex.flex-row.align-items-center
        span.menu-title.flex-grow-1 宛先を選択してください。
      button.close(type="button" @click="cancel") ×

    .send-message-target-modal-body
      //- resident group filter
      .mb-2.d-flex.flex-row.align-items-center
        span.table-option-text 利用者グループ：
        .filter
          b-form-select(id="group-filter" v-model="filter.group" :options="filterOptions" size="md")
      //- resident name, room name, family name filter
      .mb-2.d-flex.flex-row.align-items-center
        b-form-input(id="text-filter" v-model="filter.text" name="text-filter" placeholder="部屋名・利用者名・家族名を検索" aria-describedby="text-filter" data-vv-as="テキスト検索")
      //- list
      b-list-group
        template(v-if="_value.length < 1")
          span.error-message 家族が登録されていません。
        template(v-if="resident.show == true" v-for="resident in _value")
          b-list-group-item.list-group-title
            span {{ resident.name }}
          b-list-group-item(v-if="family.show == true" v-for="family in resident.targets" :key="family.id + '-' + family.familyId")
            b-form-checkbox(v-model="family.isTarget" v-if="family.senderType == 0" size="sm") {{ family.familyName }}（{{ getFamilyPositionAndRelation(family) }}）
            b-form-checkbox(v-model="family.isTarget" v-if="family.senderType == 1" size="sm") {{ family.familyName }}（メール）（{{ getFamilyPositionAndRelation(family) }}）

    template(#modal-footer="{ ok, cancel }")
      b-button.btn.modal-ok-btn(v-if="_checked" type="button" @click="ok()") OK
      b-button.btn.modal-ok-btn.disable(v-else type="button" disabled) OK
      b-button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { FamilyGetModel } from "@/commons/services/Families";

/**
 * 「家族個別」宛先リストモーダル
 */
@Component
export default class SendMessageTargetFamilyModal extends Vue {
  /** 宛先候補 */
  @Prop({ required: true })
  value!: Array<SendMessageTargetFamilyModalModel>;
  /** 表示可否 */
  @Prop({ required: true })
  show!: boolean;
  /** フィルタリング項目 */
  @Prop({ required: true })
  filterOptions!: Array<SendMessageTargetFamilyModalFilterOption>;

  /** フィルタ */
  filter: { group: string; text: string } = { group: "0", text: "" };

  get _value(): Array<SendMessageTargetFamilyModalModel> {
    // 宛先グループ==全て（0）かつ、テキスト検索==空の場合は全て表示する
    if (this.filter.group == "0" && this.filter.text == "") {
      for (const resident of this.value) {
        resident.show = true;
        for (const target of resident.targets) {
          target.show = true;
        }
      }
    }
    // 宛先グループ!=全て（0）かつ、テキスト検索==空の場合は利用者グループでフィルタリングして表示する
    else if (this.filter.group != "0" && this.filter.text == "") {
      for (const resident of this.value) {
        const show: boolean = this.filter.group == String(resident.groupId) ? true : false;
        resident.show = show;
        for (const target of resident.targets) {
          target.show = show;
        }
      }
    }
    // 宛先グループ==全て（0）かつ、テキスト検索!=空の場合はキーワードでフィルタリングして表示する
    else if (this.filter.group == "0" && this.filter.text != "") {
      const words: string[] = this.$filterUtil.createSearchWord(this.filter.text);
      for (const resident of this.value) {
        let residentShow: boolean = false;
        for (const target of resident.targets) {
          for (const word of words) {
            if (-1 < target.name.indexOf(word)) {
              target.show = true;
              residentShow = true;
              break;
            }
            if (-1 < target.room.indexOf(word)) {
              target.show = true;
              residentShow = true;
              break;
            }
            if (-1 < target.familyName.indexOf(word)) {
              target.show = true;
              residentShow = true;
              break;
            }
            target.show = false;
          }
        }
        resident.show = residentShow;
      }
    }
    // 宛先グループ!=全て（0）かつ、テキスト検索!=空の場合は利用者グループでフィルタリング後、キーワードでフィルタリングして表示する
    else if (this.filter.group != "0" && this.filter.text != "") {
      const words: string[] = this.$filterUtil.createSearchWord(this.filter.text);
      for (const resident of this.value) {
        let residentShow: boolean = false;
        const show: boolean = this.filter.group == String(resident.groupId) ? true : false;
        for (const target of resident.targets) {
          if (show) {
            for (const word of words) {
              if (-1 < target.name.indexOf(word)) {
                target.show = true;
                residentShow = true;
                break;
              }
              if (-1 < target.room.indexOf(word)) {
                target.show = true;
                residentShow = true;
                break;
              }
              if (-1 < target.familyName.indexOf(word)) {
                target.show = true;
                residentShow = true;
                break;
              }
              target.show = false;
            }
          } else {
            target.show = false;
          }
        }
        resident.show = show && residentShow;
      }
    }

    return this.value;
  }

  get _show(): boolean {
    return this.show;
  }

  set _show(newValue: boolean) {
    this.$emit("update:show", newValue);
    return;
  }

  get _checked(): boolean {
    for (const resident of this.value) {
      for (const family of resident.targets) {
        if (family.isTarget == true) {
          return true;
        }
      }
    }
    return false;
  }

  public getFamilyPositionAndRelation(family: SendMessageTargetFamilyModalModel): string {
    const relation: string = family.familyRelation;
    const position: string = family.familyPosition ? `・${family.familyPosition}` : "";

    return `${relation}${position}`;
  }

  /**
   * ### OKボタン押下イベント
   */
  public add(): void {
    this.filter.group = "0";
    this.filter.text = "";
    this.$emit("add");
    return;
  }

  /**
   * ### キャンセルボタン押下イベント
   */
  public cancel(): void {
    this.filter.group = "0";
    this.filter.text = "";
    this.$emit("cancel");
    return;
  }
}

export interface SendMessageTargetFamilyModalModel {
  name: string;
  familyRelation: string;
  familyPosition: string;
  groupId: number;
  targets: Array<SendMessageTargetFamilyModel>;
  show: boolean;
}
export interface SendMessageTargetFamilyModel extends FamilyGetModel {
  isTarget: boolean;
  show: boolean;
}

export interface SendMessageTargetFamilyModalFilterOption {
  value: string;
  text: string;
}
</script>

<style lang="scss" scopeed>
@import "../../../styles/mobile/_colors.scss";

.send-message-target-modal-body {
  .list-group-title {
    color: $font-accordion !important;
    background-color: $bg-accordion !important;
  }
}
</style>
